export * from './listCustomer.component';



// WEBPACK FOOTER //
// ./src/app/ListCustomer/index.ts